import { render, staticRenderFns } from "./activeText-editor.vue?vue&type=template&id=1396729c&scoped=true"
import script from "./activeText-editor.vue?vue&type=script&lang=js"
export * from "./activeText-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396729c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1396729c')) {
      api.createRecord('1396729c', component.options)
    } else {
      api.reload('1396729c', component.options)
    }
    module.hot.accept("./activeText-editor.vue?vue&type=template&id=1396729c&scoped=true", function () {
      api.rerender('1396729c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-switch/activeText-editor.vue"
export default component.exports